import { RadioButton } from "plos/src/components/forms/RadioButton";
import { RadioButtonGroup } from "plos/src/components/forms/ReactHookFormControlled/RadioButtonGroup";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TeamBuilderPreferencesFormData } from "../../../types";
import { getBudgetAllocationChoices } from "../../../utils";
import { stepContainer } from "../../teamBuilder.css";

const BudgetAllocationForm = () => {
  const { control } = useFormContext<TeamBuilderPreferencesFormData>();
  const { t } = useTranslation("onboarding");
  const budgetAllocationChoices = getBudgetAllocationChoices(t);

  return (
    <div className={stepContainer}>
      <RadioButtonGroup
        control={control}
        name="budgetAllocation"
        rules={{ required: true }}
        id="budgetAllocation"
        label={t(
          "budgetAllocationSubtitle",
          "You have a budget of £100m for a squad of 15 players, with 11 starting each Gameweek...",
        )}
        hideLabel
      >
        {budgetAllocationChoices.map(({ value, label, extendedLabel }) => (
          <RadioButton
            key={value}
            value={value}
            autoFocus={value === "balanced_spend"}
            fontWeight="regular"
            description={extendedLabel}
          >
            {label}
          </RadioButton>
        ))}
      </RadioButtonGroup>
    </div>
  );
};

export default BudgetAllocationForm;
